export default __webpack_public_path__ + "static/media/stop.3b12ed23.svg";